var _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCartSaveForLater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Cart_-_CHeck",
    "data-name": "Icon / Cart - CHeck",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 34.449,
    viewBox: "0 0 29 34.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wheels",
    transform: "translate(3.951 28.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle5359",
    d: "M-27,316.006a3.015,3.015,0,0,0-3,3,3.015,3.015,0,0,0,3,3,3.015,3.015,0,0,0,3-3A3.015,3.015,0,0,0-27,316.006Zm0,2a.985.985,0,0,1,1,1,.985.985,0,0,1-1,1,.985.985,0,0,1-1-1A.985.985,0,0,1-27,318.006Z",
    transform: "translate(30 -316.006)",
    fill: "",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle5361",
    d: "M-13,316.006a3.015,3.015,0,0,0-3,3,3.015,3.015,0,0,0,3,3,3.015,3.015,0,0,0,3-3A3.015,3.015,0,0,0-13,316.006Zm0,2a.985.985,0,0,1,1,1,.985.985,0,0,1-1,1,.985.985,0,0,1-1-1A.985.985,0,0,1-13,318.006Z",
    transform: "translate(30 -316.006)",
    fill: "",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Cart",
    d: "M-32.951,294a1,1,0,0,0-1,1,1,1,0,0,0,1,1h1.18l2.65,13.242A3.017,3.017,0,0,0-30.951,312a3.016,3.016,0,0,0,3,3h17a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-17a.977.977,0,0,1-1-1,.977.977,0,0,1,1-1h15l.029-.006h2.971a1,1,0,0,0,.988-.844l1.55-4.307a1,1,0,0,0-.179-.745,1,1,0,0,0-.653-.4,1,1,0,0,0-.745.18,1,1,0,0,0-.4.654l-1.417,3.461H-27.131l-1.8-8.994h9.084a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-9.484l-.639-3.2a1,1,0,0,0-.98-.8Z",
    transform: "translate(33.951 -287.557)",
    fill: "",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Check_Mark",
    "data-name": "Check Mark",
    transform: "translate(12.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-bookmark-border",
    "data-name": "Icon material-bookmark-border",
    d: "M21.22,4.5H9.787A2.284,2.284,0,0,0,7.511,6.787L7.5,25.08l8-3.43,8,3.43V6.787A2.293,2.293,0,0,0,21.22,4.5Zm0,17.15L15.5,19.158,9.787,21.65V6.787H21.22Z",
    transform: "translate(-7.5 -4.5)",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartSaveForLater);
export default __webpack_public_path__ + "static/media/Icon - cartSaveForLater.afa3946de356d725838996be965d4466.svg";
export { ForwardRef as ReactComponent };